import React from 'react';
import { AreasContext } from './AreasProvider';

export function withAreaGetter(Component) {
  let comp = function AreaContent(props) {
    return (
      <AreasContext.Consumer>
        {value => <Component {...props} areas={value.areas} getElemByAreaKey={value.getElemByAreaKey} />}
      </AreasContext.Consumer>
    );
  };
  comp.displayName = `withAreaGetter(${getDisplayName(Component)})`;
  return comp;
}

export function withAreaSetter(Component) {
  let comp = function AreaContent(props) {
    return <AreasContext.Consumer>{value => <Component {...props} setElemByAreaKey={value.setElemByAreaKey} />}</AreasContext.Consumer>;
  };
  comp.displayName = `withAreaSetter(${getDisplayName(Component)})`;
  return comp;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
